module.exports = __webpack_public_path__ + "img/map.ffd19f1b.svg";